import React from 'react'
import { Box, Text } from 'grommet'
import styled from 'styled-components'

const IconBox = styled(Box)`
  height: ${props => (props.small ? '3.2rem' : '4.2rem')};
  width: ${props => (props.small ? '3.2rem' : '4.2rem')};
  /* @media (max-width: 449px) {
    height: 3.2rem;ß
    width: 3.2rem;
  } */
`

const Label = styled(Text)`
  font-size: ${props => (props.small ? '1.4rem' : '1.6rem')};
  line-height: 1;
  color: rgba(255, 255, 255, 0.8);
  /* @media (max-width: 449px) {
    font-size: 1.4rem;
  } */
`

const ActionButton = ({ icon, label, background, onClick, small }) => {
  return (
    <Box align="center">
      <IconBox
        background={background}
        align="center"
        justify="center"
        round={true}
        onClick={onClick}
        small={small}
      >
        {icon}
      </IconBox>
      <Label textAlign="center" small={small}>
        {label}
      </Label>
    </Box>
  )
}

export default ActionButton
